// extracted by mini-css-extract-plugin
export default {"container":"style_container__06WFX","main":"style_main__MXOJg"};